import api from "../network/apiConfig";

/**
 * Generates error from the error object
 * @param {Object} error The error object
 * @returns {Object} The generated error
 */
function errorGenerator(error) {
  const info = {};

  if (error?.response) {
    Object.assign(info, {
      data: error.response.data,
      error: error.response.status,
    });
  } else {
    Object.assign(info, {
      data: { message: "Something went wrong" },
      error: "Bad Network",
    });
  }

  return info;
}

/**
 * Logs a user in by calling proper API
 * @param {Object} data contains username password
 * @returns {Object} Login response
 */
const login = async (data) => {
  try {
    const result = await api.post("/login", data);

    //console.log(result);
    if (result.status === 200 && result.data && result.data.access_token) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const logout = async (data) => {
  try {
    const result = await api.post("/logout", data);
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const getChallanList = async (endpoint, params) => {
  try {
    const result = await api.get(endpoint, { params });
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const downloadReport = async () => {
  const time = new Date().valueOf();

  const prefixUrl = `/portal/daily-report?timestamp=${time}`;

  try {
    const response = await api.get(`${prefixUrl}`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");

    const date = new Date();

    const fileName = `Challan_Report_${date}.csv`;

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    return { error: null };
  } catch (error) {
    return { error };
  }
};

const downloadCurrentReport = async (params, body) => {
  const prefixUrl = `/portal/csv-report`;

  try {
    const response = await api.post(`${prefixUrl}`, body, {
      responseType: "blob",
      params,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");

    const date = new Date();

    const fileName = `Challan_Report_${date}.csv`;

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    return { error: null };
  } catch (error) {
    return { error };
  }
};

const getAnalyticsInfo = async (params) => {
  try {
    const result = await api.get("/portal/stats", { params });
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

export {
  login,
  getChallanList,
  downloadReport,
  getAnalyticsInfo,
  logout,
  downloadCurrentReport,
};
